import React, { useState, useEffect, useMemo } from "react";
import DashboardLayout from "../../molecules/DashboardLayout";
import { Row, Col, Pagination, Card, Button } from "antd";
import { SectionHeaderV2 } from "../../organism/SectionHeaderV2";
import Grid from "../../atoms/Grid";
import DragAndDropList from "../../atoms/Grid/gridColumnSort";
import { EditOutlined, EyeOutlined, FilterOutlined } from "@ant-design/icons";
import Title from "antd/es/typography/Title";
import { Popup } from "../../atoms/Popup";
import LoaderTsx from "../Loader.tsx";
import { useFilterOptions } from "../../../hooks/useFilterOptions";
import { useApiWithFilters } from "../../../hooks/search/useApiWithFilters";
import AddOwner from "./AddOwner";
import { filterStatus, gridProps, limit, ownerGridColumn, searchKeys } from "./utili";
import BankAccountDetails from "./BankAccountDetails";
import { getGridSettings } from "../../../utils/globalService";
import { useGridReset } from "../../../hooks/useGridReset";

export default React.memo((props) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [visible, setVisible] = useState(false);
  const [trigger, setTrigger] = useState(0);
  const [editAbleRecord, setEditAbleRecord]: any = useState(null);
  const [ownerColumn, setOwnerColumns] = useState([]);
  const [selectedSearchBy, setSelectedSearchBy] = useState("name");
  const [searchValue, setSearchValue] = useState("");
  const [isSubmit, setIsSubmit] = useState(false);
  const [detectColumnChanges, setDetectColumnChanges] = useState(false);
  const { filterOptions, setSelectedPropertyId, setSelectedUnitId, selectedPropertyId, selectedUnitId } =
    useFilterOptions({ filterStatus });
  const { resetGrid, setGridReset } = useGridReset();

  const params = useMemo(() => ({
  limit: 20,
  page: currentPage,
  searchBy: selectedSearchBy,
  text: searchValue,
  propertyId: selectedPropertyId,
  unitId: selectedUnitId,
}), [
  currentPage,
  selectedSearchBy,
  searchValue,
  selectedPropertyId,
  selectedUnitId,
]);

  const {
    data: result,
    loading: isLoading,
    error,
    fetchData,
  } = useApiWithFilters({
    apiUrl: "/property/owner",
    method: "GET",
    // initialParams: { limit: 20, page: currentPage },
  });

  useEffect(() => {
    fetchData({
      limit:20,
      searchBy: selectedSearchBy,
      text: searchValue,
      propertyId: selectedPropertyId,
      unitId: selectedUnitId,
      page: currentPage,
    });
  }, [params]);

  const ViewBankAccounts = (record) => {
    return (
      <div className="d-flex align-items-center">
        <Button
          type="text"
          size="small"
          onClick={() => {
            setVisible(true);
            setTrigger(1);
            setEditAbleRecord(record);
          }}
        >
          <EyeOutlined /> View Detail
        </Button>
      </div>
    );
  };

  const getGridConfig = async () => {
    let result = await getGridSettings("owners", ownerGridColumn(MoreAction, ViewBankAccounts), resetGrid);
    setOwnerColumns(result);
    setGridReset(false);
  };

  useEffect(() => {
    getGridConfig();
  }, [resetGrid]);

  const editOwner = (record) => {
    setEditAbleRecord(record);
    setVisible(true);
    setTrigger(0);
  };
  const MoreAction = (record) => {
    return (
      <div className="d-flex align-items-center">
        <Button type="text" size="small" onClick={() => editOwner(record)}>
          <EditOutlined />
        </Button>
      </div>
    );
  };
  const addNewOwner = () => {
    setEditAbleRecord(null);
    setVisible(true);
    setTrigger(0);
  };

  const handlePagination = (pg) => {
    setCurrentPage(pg);
  };

  function handlePropertyChange(filterValue, filterName) {
    if (filterName === "property") {
      setSelectedPropertyId(filterValue?.value);
    } else if (filterName === "unit") {
      setSelectedUnitId(filterValue?.value);
    }
    setCurrentPage(1);
  }

  const popup = [
    {
      title: (
        <Title level={3} className="m-0">
          {editAbleRecord ? "Edit Owner" : "Add New Owner"}
        </Title>
      ),
      content: (
        <AddOwner
          isSubmit={isSubmit}
          setIsSubmit={setIsSubmit}
          setVisible={setVisible}
          editAbleRecord={editAbleRecord}
        />
      ),
      width: 1150,
      style: { padding: "0px" },
    },

    {
      title: (
        <Title level={3} className="m-0">
          Bank Accounts
        </Title>
      ),
      content: <BankAccountDetails ownerId={editAbleRecord?.ownerId} />,
      width: 650,
      style: { padding: "0px" },
    },
  ];

  const popupProps = {
    closable: true,
    visibility: visible,
    title: popup[trigger].title,
    content: popup[trigger].content,
    width: popup[trigger].width,
    style: popup[trigger]?.style,
    onCancel: () => setVisible(false),
  };

  return (
    <>
      <DashboardLayout load={false}>
        <Row gutter={[32, 32]}>
          <Col span={24}>
            <Row gutter={[24, 24]}>
              <Col span={24}>
                <SectionHeaderV2
                  heading="Owners"
                  noBorder={true}
                  total={result?.result?.totalCount || 0}
                  addNewAction={addNewOwner}
                  dropTrigger={["click"]}
                  onSearch={(e) => setSearchValue(e)}
                  onChangeSearchBy={(e) => setSelectedSearchBy(e?.value)}
                  defaultSearch={searchValue}
                  searchByOptions={searchKeys}
                  viewOption={filterOptions}
                  viewOptionIcon={<FilterOutlined />}
                  justifiedItems={true}
                  justifyEnd={true}
                  handleView={handlePropertyChange}
                />
              </Col>

              <Col span={24} className="managers_tenants_detail" style={{ width: "100%" }}>
                {isLoading ? (
                  <LoaderTsx />
                ) : (
                  <>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "2.75rem",
                        width: "100%",
                        marginInline: "-0.25rem",
                      }}
                    >
                      <div style={{ flex: 1 }}>
                        <Pagination
                          pageSize={result?.result?.perPage || limit}
                          className="ag-property-text-pagination"
                          total={result?.result?.totalCount || 0}
                          showTotal={(total, range) => `Showing ${range[0]}-${range[1]} of ${total} Owners`}
                          defaultPageSize={result?.result?.perPage || 20}
                          defaultCurrent={1}
                          showSizeChanger={false}
                          current={currentPage}
                          onChange={(e) => handlePagination(e)}
                        />
                      </div>

                      <DragAndDropList
                        columns={ownerColumn}
                        setModifiedColumns={setOwnerColumns}
                        changePicker={setDetectColumnChanges}
                        detectColumnChanges={detectColumnChanges}
                        screenName="owners"
                        setGridReset={setGridReset}
                      />
                    </div>
                    <Card bordered={false} className="ag-nospace-body">
                      <Grid
                        data={result?.result?.data || []}
                        gridClassName="full-width-grid"
                        columns={ownerGridColumn(MoreAction, ViewBankAccounts, ownerColumn) || []}
                        pagination={false}
                        defaultSettings={gridProps}
                        noRowlabel="Tenants"
                        rowSelection="multiple"
                        isRowSelectable={false}
                        fullPage={true}
                      />
                    </Card>
                  </>
                )}
              </Col>
            </Row>
          </Col>
        </Row>
      </DashboardLayout>
      <Popup destroyOnClose={true} {...popupProps} />
    </>
  );
});
